/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientDecision = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered'
} as const;
export type ClientDecision = typeof ClientDecision[keyof typeof ClientDecision];


export function ClientDecisionFromJSON(json: any): ClientDecision {
    return ClientDecisionFromJSONTyped(json, false);
}

export function ClientDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDecision {
    return json as ClientDecision;
}

export function ClientDecisionToJSON(value?: ClientDecision | null): any {
    return value as any;
}

